module.exports = __webpack_public_path__ + "static/media/safe-care.f504109a.png";